import React from 'react'
import UserSettingsShell from '@/modules/user-settings/components/UserSettingsShell'
import BankAccountsManager from '@/modules/affiliates/components/BankAccountsManager'
import UserRegionSettingsCard from '@/modules/user-settings/components/UserRegionSettingsCard'
import UserNotificationsSection from '@/modules/user-settings/components/UserNotificationsSection'

export default function AffiliateUserSettingsPage() {
  return (
    <div className="w-full">
      <h1 className="mb-4 text-2xl font-semibold">Configurações</h1>
      <UserSettingsShell
        items={[
          { key: 'bank', label: 'Dados bancários', render: () => <BankAccountsManager /> },
          { key: 'region', label: 'Localização e horário', render: () => <UserRegionSettingsCard /> },
          { key: 'notifications', label: 'Notificações', render: () => <UserNotificationsSection /> },
        ]}
        initial="bank"
      />
    </div>
  )
}

